import React from 'react';
import { usersLoginApi } from '../services/apiService'
import {
  Form, Icon, Input, Button } from 'antd';

class NormalLoginForm extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      //if (!err) {
      //  console.log('Received values of form: ', values);
      //}
      let { UserName, Password } = values;
      let request = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ UserName, Password })
      }

      usersLoginApi(request)
        .then(json => {
          if (typeof json === "string") {
            let errorMessage = json
            if (json === "Error: 401") {
              errorMessage = "Invalid user name or password"
            }
            this.props.form.setFields({
              Password: {
                value: null,
                errors: [new Error(errorMessage)]
              }
            })
          }
          else {
            window.sessionStorage.setItem("UserName", json.username)
            window.sessionStorage.setItem("UserRole", json.role)
            window.sessionStorage.setItem("OrganisationName", json.organisationName)
            window.sessionStorage.setItem("OrganisationId", json.organisationId)
            window.sessionStorage.setItem("Address", json.address)
            window.sessionStorage.setItem("jwtToken", json.token)
            window.sessionStorage.setItem("email", json.email)
            let version = json.version || '';
            window.location.href = "/?v="+version;
          }
        })
        .catch(err => {
          console.error(  err)
        })


    });
  }

  render() {
    const formItemLayout =
         {
          labelCol: { span: 8 },
          wrapperCol: { span: 16 },
        }
        
    const tailFormItemLayout = {
      wrapperCol: {
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form" {...formItemLayout}>
        <div  style={{ padding: 10 }}>
          <h2>Church Helper Online</h2>
        </div>
        <Form.Item label="Username">
          {getFieldDecorator('UserName', {
            rules: [{ required: true, message: 'Please input your username!' }],
          })(
            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
          )}
        </Form.Item>
        <Form.Item label="Passowrd">
          {getFieldDecorator('Password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
          )}
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <a className="login-form-forgot" href="/recover">Forgot password</a>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Log in
            </Button>
        </Form.Item>
      </Form>
    );
  }
}

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(NormalLoginForm);

export default WrappedNormalLoginForm;